import React from "react";

import { CSVBoxButton } from "@csvbox/react";
import {toast} from "react-toastify";

const CsvBoxxComponent = () => {
    const user_id = localStorage.getItem('user_id');
    const token = localStorage.getItem('token');
    
    return (
        <CSVBoxButton 
            licenseKey="eFVUWXI3g7OFbNyjZRsLHH8VXXZ2Xn"
            lazy={true}
            user={{
                user_id: user_id
            }}
            onImport={(result, data) => {
                if (result) {
                    toast.success('Import Completed Successfully!');
                    setTimeout(() => {
                        window.location.href = "/purchases";
                    }, 2000);
                } else {
                    toast.error('here was an issue with your upload. We’re working a solution and will get back shortly.');
                }
            }}
            loadStarted={() => {
                console.log("loadStarted");

            }}
            onReady={() => {
                console.log("onReady");
            }}
            onClose={() => {
                console.log("onclosed");
            }}
            onSubmit={(data) => {
                console.log("onSubmit");
                console.log(data.import_id);
            }} 
             options={{
                  request_headers: {
                      "Authorization": "Bearer " + token
                  },
              }}
        >
            <i style={{fontSize: '16px', fontWeight: 'bold'}} className="ti-import"></i> Import
        </CSVBoxButton>
    );
};

export default CsvBoxxComponent;